/* eslint-disable no-throw-literal */
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import actions from "./actions";
import CONSTANTS from "./CONSTANTS";
import { toast } from "react-toastify";
import blobDownload from "shared-components-package/dist/hooks/blobDownload";
import authActions from "../auth/actions";
import { v4 as uuidv4 } from "uuid";
import { formatByIdSaga } from "../helpers/formatByIdSaga";
export const SERVICE_CENTER_URL =
  "/services/rcp/profile/appointment/servicepoint/";
export const POLICY_URL = "/services/rcp/profile/policy/";
export const DOC_URL = "/services/rcp/profile/appointment/doctor/";
const BENEFITS_URL = "/services/benefit/GetBenefits";
const ACCOUNT_URL = "/services/rcp/profile/account/";
const questionaryUrl = "/services/rcp/profile/questionary/";
const personaldoctorsUrl = "/services/rcp/profile/personaldoctors/";
const RELATIVES_URL = "/services/rcp/profile/relatives/";
const PRODUCTS_URL = "/services/rcp/profile/products/";
const COMPENSIONS_URL = "/services/rcp/profile/compensations/";
const APPEALS_URL = "/services/rcp/profile/appeals/";
const COMMON = "/services/common/";
const baseUrlCmm = "/services/rcp/profile/common/";
const specialistGuarantessUrl =
  "/services/rcp/profile/appeals/specialistguarantees/";
const medUrl = "/services/rcp/profile/appeals/medambguarantees/";
// "/services/rcp/profile/appointment/doctor"
// "/services/rcp/profile/appointment/servicepoint"
// "/services/rcp/profile/appeals"
// "/services/rcp/profile/compensations"
// /services/rcp/profile/account

export function* getActiveBenefits() {
  yield takeLatest(CONSTANTS.GET_MAIN_ACTIVE_BENEFITS, function* (action) {
    try {
      yield put(actions.setActiveBenefits(null));

      const url = BENEFITS_URL;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setActiveBenefits(data));
    } catch (e) {
      yield put(actions.setActiveBenefits([]));
      console.error(e);
    }
  });
}

export function* getMyPolicies() {
  yield takeLatest(CONSTANTS.GET_MAIN_MY_POLICIES, function* () {
    try {
      yield put(actions.setMyPolicies(null));

      const url = POLICY_URL + "GetMyPolicies" + "?showChildPolicies=true";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setMyPolicies(data));
    } catch (e) {
      yield put(actions.setMyPolicies([]));
      console.error(e);
    }
  });
}

export function* getMyDoctor() {
  yield takeLatest(CONSTANTS.GET_MAIN_MY_DOCTOR, function* (action) {
    try {
      yield put(actions.setMyDoctor(undefined));
      const urlExtension =
        action.payload?.isChild === true
          ? `?policyId=${action.payload?.policyId}`
          : "";
      const url = DOC_URL + "GetMyDoctor" + urlExtension;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;
      yield put(actions.setMyDoctor(data));
    } catch (e) {
      yield put(actions.setMyDoctor(undefined));
      console.error(e);
    }
  });
}

export function* getMyManagerByPolicyId() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_MY_MANAGER_BYPOLICYID,
    function* (action) {
      try {
        yield put(actions.setMyManagerByPolicyId(null));

        const url =
          POLICY_URL + "GetMyManagerByPolicyId?policyId=" + action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const data = res.data;

        yield put(actions.setMyManagerByPolicyId(data));
      } catch (e) {
        yield put(actions.setMyManagerByPolicyId({}));
        console.error(e);
      }
    }
  );
}

export function* getPlannedVisitsDoctor() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_PLANNED_VISITS_DOCTOR,
    function* (action) {
      try {
        yield put(actions.setPlannedVisitsDoctor(undefined));

        const url = DOC_URL + "PlannedVisitsDoctor?policyId=" + action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const data = res.data;

        yield put(actions.setPlannedVisitsDoctor(data));
      } catch (e) {
        yield put(actions.setPlannedVisitsDoctor([]));
        console.error(e);
      }
    }
  );
}

export function* getPlannedVisitsServiceCenter() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_PLANNED_VISITS_SERVICE_CENTER,
    function* (action) {
      try {
        yield put(actions.setPlannedVisitsServiceCenter(undefined));

        const url =
          SERVICE_CENTER_URL +
          "PlannedVisitsServiceCenter?policyNo=" +
          action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const data = res.data;

        yield put(actions.setPlannedVisitsServiceCenter(data));
      } catch (e) {
        yield put(actions.setPlannedVisitsServiceCenter([]));
        console.error(e);
      }
    }
  );
}
export function* changePassword() {
  yield takeLatest(CONSTANTS.GET_MAIN_CHANGE_PASSWORD, function* (action) {
    try {
      yield put(actions.setChangePassword(null));

      const url = ACCOUNT_URL + "changepassword";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      const message = yield formatByIdSaga("notifications.passwordChanged");
      toast.success(message);

      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setChangePassword(true));
    } catch (e) {
      if (e?.response.data.status === 400) {
        const errors = e?.response?.data?.errors?.NewPassword;
        console.log(errors);
        yield put(
          actions.setChangePassword({
            success: false,
            exceptionCode: e?.response?.data?.errors?.NewPassword || null,
          })
        );
      } else {
        yield put(actions.setChangePassword(e?.response?.data));
      }

      console.error(e);
    }
  });
}

export function* getPersonalInfo() {
  yield takeLatest(CONSTANTS.GET_MAIN_PERSONALINFO, function* () {
    try {
      yield put(actions.setPersonalInfo({}));

      const url = ACCOUNT_URL + "myprofile";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const data = res.data;

      yield put(actions.setPersonalInfo(data));
    } catch (e) {
      yield put(actions.setPersonalInfo({}));
      console.error(e);
    }
  });
}

export function* getInsuranceProductsByUser() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_INSURANCE_PRODUCTS_BY_USER,
    function* (action) {
      try {
        yield put(actions.setInsuranceProductsByUser(null));

        const url =
          PRODUCTS_URL +
          `GetInsuranceProductsByUser?policyId=${action.payload}`;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };
        const data = res.data;

        yield put(actions.setInsuranceProductsByUser(data));
      } catch (e) {
        yield put(actions.setInsuranceProductsByUser([]));
        console.error(e);
      }
    }
  );
}

export function* getRemunerationsDashbord() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_REMUNERATIONS_DASHBOARD,
    function* (action) {
      try {
        yield put(actions.setRemunerationsDashbord(null));

        const url =
          COMPENSIONS_URL +
          "GetRemunerationsDashbord?policyId=" +
          action.payload;
        const res = yield window.mainAxios.get(url).then((r) => r.data);
        // console.log(res)
        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };
        const data = res.data;

        yield put(actions.setRemunerationsDashbord(data));
      } catch (e) {
        yield put(actions.setRemunerationsDashbord([]));
        console.error(e);
      }
    }
  );
}

export function* getdashboardAppeals() {
  yield takeLatest(CONSTANTS.GET_MAIN_DASHBOARD_APPEALS, function* (action) {
    try {
      yield put(actions.setdashboardAppeals(null));

      const url =
        APPEALS_URL + "GetdashboardAppeals?policyId=" + action.payload;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const data = res.data;

      yield put(actions.setdashboardAppeals(data));
    } catch (e) {
      yield put(actions.setdashboardAppeals([]));
      console.error(e);
    }
  });
}

export function* getDeleteReservation() {
  yield takeLatest(CONSTANTS.GET_MAIN_DELETE_RESERVATION, function* (action) {
    try {
      yield put(actions.setDeleteReservation(null));

      const url =
        "/services/rcp/profile/appointment/servicepoint/" +
        "DeleteReservation?oid=" +
        action.payload;
      const res = yield window.mainAxios.delete(url).then((x) => x.data);

      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const message = yield formatByIdSaga("notifications.consultationDeleted");
      toast.success(message);

      yield put(actions.setServiceCenterUpdateCounter());
      yield put(actions.setDeleteReservation(true));
    } catch (e) {
      const message = yield formatByIdSaga(
        "notifications.consultationCouldntBeDeleted"
      );
      toast.error(message);

      yield put(actions.setDeleteReservation(false));
    }
  });
}

export function* getFileData() {
  yield takeLatest(CONSTANTS.GET_MAIN_FILE_DATA, function* (action) {
    try {
      ////baseUrl needs change
      const url = `${COMMON}GetFileData?oid=${action.payload}`;

      yield blobDownload(url);
    } catch (e) {
      const message = yield formatByIdSaga("notifications.couldntGetInfo");
      toast.error(message);
    }
  });
}

export function* getFindChildren() {
  yield takeLatest(CONSTANTS.GET_FIND_CHILDREN, function* () {
    try {
      yield put(actions.setFindChildren(null));

      const url = RELATIVES_URL + "findchildren";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setFindChildren(data));
    } catch (e) {
      yield put(actions.setFindChildren([]));
      console.error(e);
    }
  });
}
export function* getAddedChildren() {
  yield takeLatest(CONSTANTS.GET_ADDED_CHILDREN, function* () {
    try {
      yield put(actions.setAddedChildren(null));

      const url = RELATIVES_URL + "addedchildren?showAllChildren=true";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setAddedChildren(data));
    } catch (e) {
      yield put(actions.setAddedChildren([]));
      console.error(e);
    }
  });
}

export function* getAddchild(setLoading) {
  yield takeLatest(CONSTANTS.GET_ADD_CHILD, function* (action) {
    try {
      yield put(actions.setAddchild(false));

      const url = RELATIVES_URL + "addchild";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success) {
        toast.error(res.ExceptionMessage);
        yield put(actions.setAddchild(false, setLoading(false)));
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      }

      yield put(actions.setAddchild(true));
    } catch (e) {
      yield put(actions.setAddchild(false));
      console.error(e);
    }
  });
}
export function* getCheckChild() {
  yield takeLatest(CONSTANTS.GET_CHECK_CHILD, function* (action) {
    try {
      yield put(actions.setCheckChild(false));

      const url = RELATIVES_URL + "checkchild";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setCheckChild(res.data));

      if (!res.data) {
        yield put(actions.setCheckChild(null));
      }
    } catch (e) {
      yield put(actions.setCheckChild(undefined));
      console.error(e);
    }
  });
}
export function* getInsurerMobile() {
  yield takeLatest(CONSTANTS.GET_INSURER_MOBILE, function* () {
    try {
      yield put(actions.setInsurerMobile(null));

      const url = RELATIVES_URL + "insurermobile";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setInsurerMobile(data));
    } catch (e) {
      yield put(actions.setInsurerMobile([]));
      console.error(e);
    }
  });
}
export function* getSendOTPInsurer() {
  yield takeLatest(CONSTANTS.GET_SEND_OTP_INSURER, function* (action) {
    try {
      yield put(actions.setSendOTPInsurer(null));

      const url = RELATIVES_URL + "sendotptoinsurer";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      yield put(actions.setSendOTPInsurer(true));
    } catch (e) {
      yield put(actions.setSendOTPInsurer(false));
      console.error(e);
    }
  });
}
export function* getSwitchUser() {
  yield takeLatest(CONSTANTS.GET_SWITCH_USER, function* (action) {
    yield put(authActions.loading(true));

    try {
      const { data } = yield window.mainAxios.post(
        RELATIVES_URL + "switchuser",
        action.payload
      );

      if (data.success) {
        localStorage.setItem("act", data.data.accessToken);
        localStorage.setItem("rft", data.data.refreshToken);
        localStorage.setItem("alm", data.data.autoLogoutMinute);
        localStorage.setItem("ImageHasUpdated", uuidv4().toString());

        // yield put(authActions.loginSuccess({ UserName: action.pId }));
        // yield put(
        //   authActions.userMustChangePassword(data.data.userMustChangePassword)
        // );
        yield put(authActions.loading(false));
        yield put(actions.setSwitchUser(true));
      }
    } catch (e) {
      yield put(actions.setSwitchUser(false));

      const message = yield formatByIdSaga("notifications.wrongUserName");
      toast.error(message);

      console.log(e);
      yield put(authActions.loading(false));
    }
  });
}

export function* getTechnicalMessages() {
  yield takeLatest(CONSTANTS.GET_MAIN_TECHICAL_MESSAGE, function* (action) {
    try {
      yield put(actions.setTechnicalMessages(null));

      const url = baseUrlCmm + "GetTechnicalMessages";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      yield put(actions.setTechnicalMessages(res));
    } catch (e) {
      yield put(actions.setTechnicalMessages(null));
      console.error(e);
    }
  });
}

export function* getCancelReservation() {
  yield takeLatest(CONSTANTS.GET_MAIN_CANCEL_RESERVATION, function* (action) {
    try {
      yield put(actions.setDeleteReservation(null));

      const url = DOC_URL + "CancelReservation";
      const res = yield window.mainAxios
        .post(url, action.payload)
        .then((x) => x.data);

      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      const message = yield formatByIdSaga(
        "notifications.successfullyCanceled"
      );
      toast.success(message);
      yield put(
        actions.setUpdatePlannedVisitsDoctor(action.payload?.ReservationId)
      );
      yield put(actions.setServiceCenterUpdateCounter());
      yield put(actions.setDeleteReservation(true));
    } catch (e) {
      const message = yield formatByIdSaga(
        "notifications.couldntCancelConsultation"
      );
      toast.error(message);

      yield put(actions.setDeleteReservation(false));
    }
  });
}

export function* getAddReservationDocuments() {
  yield takeLatest(
    CONSTANTS.GET_MAIN_ADD_RESERVATION_DOCUMENTS,
    function* (action) {
      try {
        yield put(actions.setAddReservationDocuments(null));

        const formData = new FormData();
        formData.append("reservationId", action.payload.ReservationId);
        formData.append("patientComment", action.payload.PatientComment);

        const doctorPrescriptionDocumentsArray = Array.from(
          action.payload.DoctorPrescriptionDocuments
        );
        const researchResultsDocumentsArray = Array.from(
          action.payload.ResearchResultsDocuments
        );

        doctorPrescriptionDocumentsArray.forEach((file, _) => {
          formData.append(`DoctorPrescriptionDocuments`, file);
        });

        researchResultsDocumentsArray.forEach((file, _) => {
          formData.append(`ResearchResultsDocuments`, file);
        });

        const url = DOC_URL + "AddReservationDocuments";
        const res = yield window.mainAxios
          .post(url, formData)
          .then((x) => x.data);

        // eslint-disable-next-line no-throw-literal
        if (!res.success)
          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        const message = yield formatByIdSaga(
          "notifications.informationSuccessfullyShared"
        );
        toast.success(message);
        yield put(actions.setAddReservationDocuments(true));
      } catch (e) {
        const message = yield formatByIdSaga(
          "notifications.couldntshareDetails"
        );
        toast.error(message);

        yield put(actions.setAddReservationDocuments(false));
      }
    }
  );
}

export function* getQuestionStatus() {
  yield takeLatest(CONSTANTS.GET_MAIN_QUESTION_STATUS, function* () {
    try {
      yield put(actions.setQuestionStatus());

      const url = questionaryUrl + "status";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setQuestionStatus(data));
    } catch (e) {
      yield put(actions.setQuestionStatus());
      console.error(e);
    }
  });
}

export function* getCanChangePersonalDoctor() {
  yield takeLatest(CONSTANTS.GET_DOCTORS_CAN_CHANGE_PERSONAL_DOC, function* () {
    try {
      yield put(actions.setCanChangePersonalDoctor(undefined));

      const url = personaldoctorsUrl + "CanChangePersonalDoctor";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setCanChangePersonalDoctor(data));
    } catch (e) {
      yield put(actions.setCanChangePersonalDoctor(false));
      console.error(e);
    }
  });
}
// function checkNotificationsChanged(oldNotifications, newNotifications) {
//   if (!oldNotifications) return false;

//   const newIds = new Set(map(newNotifications, (x) => x.notificationId));
//   const oldIds = new Set(map(oldNotifications, (x) => x.notificationId));

//   return newIds.size > oldIds.size;
// }
export function* notificationRequest() {
  yield takeLatest(CONSTANTS.GET_NOTIFICATIONS_MAIN, function* (action) {
    const calledFromHub = action.payload;
    // const currentNotifications = yield select(
    //   (state) => state.common.notifications
    // );
    try {
      // if called from hub dont show loading
      if (!calledFromHub) {
        yield put(actions.setNotifications(null));
      }

      const getAllNotifications = false;
      const url = `/services/notification/GetNotifications/${getAllNotifications}`;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      const data = res.data;

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      // const notificationsChanged = yield checkNotificationsChanged(
      //   currentNotifications,
      //   data
      // );
      // if (notificationsChanged) {
      //   const toastId = "new-notifications-success";
      //   const message = yield formatByIdSaga("topbar.NewNotification");
      //   toast(message, { toastId });
      // }

      yield put(actions.setNotifications(data));
    } catch (e) {
      console.error(e);
      // const toastId = "load-notifications-error";
      // const message = yield formatByIdSaga("topbar.CouldNotLoadNotifications");
      // toast(message, { toastId });
      // if called from hub dont empty on error
      if (!calledFromHub) {
        yield put(actions.setNotifications([]));
      }
    }
  });
}
export function* readNotification() {
  yield takeLatest(CONSTANTS.READ_NOTIFICATION_MAIN, function* (action) {
    const { notificationId, callbackActions } = action.payload;

    try {
      const url = `/services/notification/MarkAsReadNotification/${notificationId}`;
      const res = yield window.mainAxios.put(url).then((r) => r.data);

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      // MOCK
      // yield delay(1000);
      // yield put(actions.setNotifications([]))

      // if successfuly read notification
      // dispatch callback actions
      // request new notifications
      yield all(callbackActions.map((action) => put(action)));
      yield put(actions.getNotifications());
    } catch (e) {
      // console.log(e);
      // const toastId = 'read-notifications-error';
      // const message = yield formatByIdSaga('topbar.CouldNotReadNotification');
      // toast(message, { toastId });
    }
  });
}
export function* getMainIsOutOfOffice() {
  yield takeLatest(CONSTANTS.GET_MAIN_IS_OUT_OF_OFFICE, function* (action) {
    try {
      yield put(actions.setMainIsOutOfOffice(false));

      const url = baseUrlCmm + "IsOutOfOffice";
      const res = yield window.mainAxios.get(url).then((x) => x.data);
      if (res?.success) {
        localStorage.setItem("isOutOfOffice", res?.data);
      }
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setMainIsOutOfOffice(res?.data));
    } catch (e) {
      yield put(actions.setMainIsOutOfOffice(false));
    }
  });
}

export function* getShowSpecialistPopup() {
  yield takeLatest(CONSTANTS.GET_SHOW_SPECIALIST_POPUP, function* () {
    try {
      yield put(actions.setShowSpecialistPopup(false));

      const url = specialistGuarantessUrl + "ShowSpecialistPopup";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data?.showPopup;

      yield put(actions.setShowSpecialistPopup(data));
    } catch (e) {
      yield put(actions.setShowSpecialistPopup(false));
      console.error(e);
    }
  });
}

export function* sendRequestReturnedMain() {
  yield takeLatest(
    CONSTANTS.GET_SEND_REQUEST_COMPESATIONS_RETURNED_MAIN,
    function* (action) {
      try {
        yield put(
          actions.setCompensationsRequestLoadingMain({
            loading: true,
            success: false,
          })
        );
        const url = `${COMPENSIONS_URL}ResubmitRemonurationShort`;
        yield put(actions.setGridSizeValidateMain(true));

        const res = yield window.mainAxios
          .post(url, action.payload.data)
          .then((x) => x.data);

        if (!res.success)
          // eslint-disable-next-line no-throw-literal

          throw {
            errorCode: res.errorCode,
            errorMessage: res.errorMessage,
          };

        yield put(actions.setGridSizeValidateMain(true));

        const lang = yield select((state) => state.common.lang);
        toast.success(
          lang === "ge"
            ? "ანაზღაურების მოთხოვნა გადაგზავნილია!"
            : "Reimbursement request sent!"
        );

        yield put(
          actions.setCompensationsRequestLoadingMain({
            loading: false,
            success: true,
          })
        );
      } catch (e) {
        yield put(
          actions.setCompensationsRequestLoadingMain({
            loading: false,
            success: false,
          })
        );
        yield put(actions.setGridSizeValidateMain(false));
      }
    }
  );
}

export function* getExtendAppeal() {
  yield takeLatest(CONSTANTS.GET_EXTEND_APPEAL, function* (action) {
    let errorStatus = "";
    try {
      yield put(actions.setExtendAppeal(undefined));
      const urlTypes = {
        Ambulatory: `${medUrl}ExtendAmbTerm`,
        Specialist: `${specialistGuarantessUrl}ExtendSpecTerm`,
      };
      const errorTypesArray = {
        Ambulatory: {
          955: "dashboardAppeals.ReferralIsActive",
          956: "dashboardAppeals.referralIsAlreadyExtended",
          957: "dashboardAppeals.cannotBeExtended",
          958: "dashboardAppeals.extensionDeadlineHasExpired",
          959: "dashboardAppeals.deadlineCannotBeExtendedWithImmuneVacinations",
          960: "dashboardAppeals.serviceLimitHasExpired",
          404: "dashboardAppeals.recordNotFound",
        },
        Specialist: {
          554: "dashboardAppeals.ReferralIsActive",
          555: "dashboardAppeals.referralIsAlreadyExtended",
          556: "dashboardAppeals.cannotBeExtended",
          557: "dashboardAppeals.extensionDeadlineHasExpired",
          558: "dashboardAppeals.deadlineCannotBeExtendedWithImmuneVacinations",
          960: "dashboardAppeals.serviceLimitHasExpired",
          404: "dashboardAppeals.recordNotFound",
        },
      };

      const urlComputed = urlTypes?.[action?.payload?.type];

      const res = yield window.mainAxios
        .post(urlComputed, { medGuaranteesAmbId: action.payload?.id })
        .then((x) => x.data)
        .catch(function (error) {
          if (error?.response) {
            // The request was made and the server responded with a status code      // that falls out of the range of 2xx

            const errorTypes = errorTypesArray?.[action?.payload?.type];
            if (
              errorTypes?.[error.response?.data?.ExceptionCode] !== undefined
            ) {
              errorStatus = errorTypes?.[error.response?.data?.ExceptionCode];
              // dispatch(actions.setValidateFilesMessage("compensations.fileSizeTooBigText"))
            } else {
              errorStatus = "";
              // dispatch(actions.setValidateFilesMessage("compensations.fileSizeNotValidated"))
            }
          } else if (error.request) {
            // The request was made but no response was received      // `error.request` is an instance of XMLHttpRequest in the browser       // and an instance of http.ClientRequest in node.js
          } else {
            // Something happened in setting up the request that triggered an Error
          }
        });

      const error = {
        exceptionCode: res.exceptionCode,
        exceptionMessage: res.exceptionMessage,
      };
      if (!res.success) throw error;
      yield put(actions.setExtendAppeal({ status: true, message: res.data }));
    } catch (e) {
    } finally {
      if (errorStatus !== "") {
        yield put(actions.setExtendAppeal(errorStatus));
      }
    }
  });
}
// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(getActiveBenefits),
    fork(getMyPolicies),
    fork(getMyDoctor),
    fork(getMyManagerByPolicyId),
    fork(getPlannedVisitsDoctor),
    fork(getPlannedVisitsServiceCenter),
    fork(changePassword),
    fork(getPersonalInfo),
    fork(getInsuranceProductsByUser),
    fork(getRemunerationsDashbord),
    fork(getdashboardAppeals),
    fork(getDeleteReservation),
    fork(getFileData),
    fork(getFindChildren),
    fork(getAddedChildren),
    fork(getAddchild),
    fork(getCheckChild),
    fork(getInsurerMobile),
    fork(getSendOTPInsurer),
    fork(getSwitchUser),
    fork(getTechnicalMessages),
    fork(getCancelReservation),
    fork(getAddReservationDocuments),
    fork(getQuestionStatus),
    fork(getCanChangePersonalDoctor),
    fork(notificationRequest),
    fork(readNotification),
    fork(getMainIsOutOfOffice),
    fork(getShowSpecialistPopup),
    fork(sendRequestReturnedMain),
    fork(getExtendAppeal),
  ]);
}
